import { Config } from "@/shared/config";
import {
    ExpenseEligibilityGroup,
    HsabExpenseByExternalIdRequest,
    ManagedExpensePageRequest
} from "@/shared/types";

const expenseServiceUri = Config.ExpenseServicebaseUri;
const expenseV1 = `${expenseServiceUri}/expense/v1`;
export default {
    get expenseV1 () {
        return `${expenseServiceUri}/expense/v1`;
    },
    get expenseV2 () {
        return `${expenseServiceUri}/expense/v2`;
    },
    getLinkedCards () {
        return `${this.expenseV1}/linkedcards`;
    },
    getExpenses (page: number, pageSize: number, eligibilityGroup: ExpenseEligibilityGroup) {
        return `${this.expenseV1}/transactions/pending/list?page=${page}` +
            `&pageSize=${pageSize}&eligibilityGroupId=${eligibilityGroup}`;
    },
    getExpensesNew () {
        return `${this.expenseV1}/transactions/expenses/list`;
    },
    searchExpenses () {
        return `${this.expenseV1}/expenses`;
    },
    putEligibilityStatus () {
        return `${this.expenseV1}/expenses/eligibilitystatus`;
    },
    getBalanceSummary () {
        return `${this.expenseV1}/balancesummary`;
    },
    expenseEdit (expenseId?: number) {
        return `${this.expenseV1}/expenses${expenseId ? "/" + expenseId : ""}`;
    },
    getProviderSearchTypeAhead (searchTerm: string) {
        return `${this.expenseV2}/expenses/provider-lookup/${searchTerm}`;
    },
    getProviderLookupPreCache () {
        return `${this.expenseV2}/expenses/provider-pre-cache`;
    },
    expenseEvidence (expenseId: number, filename?: string) {
        if (filename) {
            return `${this.expenseV1}/expense-evidence/${expenseId}/${filename}`;
        }

        return `${this.expenseV1}/expense-evidence/${expenseId}`;
    },
    expenseEvidenceS3PreSignedUrl (expenseId: number, filename?: string) {
        return `${this.expenseV1}/expense-evidence/download-link/${expenseId}/${filename}`;
    },
    getHsabExpensesByIds () {
        return `${this.expenseV2}/expenses/expenses-by-ids`;
    },
    getAvailableHsabExpenses (page: number, pageSize: number) {
        return `${this.expenseV2}/expenses/available?page=${page}&pageSize=${pageSize}`;
    },
    getManagedExpensesPage (request: ManagedExpensePageRequest) {
        let url = `${this.expenseV2}/managed-expenses?page=${request.pageNumber}&pageSize=${request.pageSize}&baseFilter=${request.baseFilter}`;
        if (request.categoryFilter) {
            url += `&categoryFilter=${request.categoryFilter}`;
        }
        if (request.startDateFilter) {
            url += `&startDateFilter=${request.startDateFilter}`;
        }
        if (request.endDateFilter) {
            url += `&endDateFilter=${request.endDateFilter}`;
        }
        if (request.textSearch) {
            url += `&textSearch=${request.textSearch}`;
        }
        if (request.sortByColumn) {
            url += `&sortByColumn=${request.sortByColumn}`;
        }
        if (request.sortOrder) {
            url += `&sortOrder=${request.sortOrder}`;
        }
        return url;
    },
    exportManagedExpensesPresignedUrl (request: ManagedExpensePageRequest) {
        let url = `${this.expenseV2}/managed-expenses/export-csv-url?baseFilter=${request.baseFilter}`;
        if (request.categoryFilter) {
            url += `&categoryFilter=${request.categoryFilter}`;
        }
        if (request.startDateFilter) {
            url += `&startDateFilter=${request.startDateFilter}`;
        }
        if (request.endDateFilter) {
            url += `&endDateFilter=${request.endDateFilter}`;
        }
        if (request.textSearch) {
            url += `&textSearch=${request.textSearch}`;
        }
        if (request.sortByColumn) {
            url += `&sortByColumn=${request.sortByColumn}`;
        }
        if (request.sortOrder) {
            url += `&sortOrder=${request.sortOrder}`;
        }
        return url;
    },
    exportManagedExpenses (request: ManagedExpensePageRequest) {
        let url = `${this.expenseV2}/managed-expenses/export-to-csv?baseFilter=${request.baseFilter}`;
        if (request.categoryFilter) {
            url += `&categoryFilter=${request.categoryFilter}`;
        }
        if (request.startDateFilter) {
            url += `&startDateFilter=${request.startDateFilter}`;
        }
        if (request.endDateFilter) {
            url += `&endDateFilter=${request.endDateFilter}`;
        }
        if (request.textSearch) {
            url += `&textSearch=${request.textSearch}`;
        }
        if (request.sortByColumn) {
            url += `&sortByColumn=${request.sortByColumn}`;
        }
        if (request.sortOrder) {
            url += `&sortOrder=${request.sortOrder}`;
        }
        return url;
    },
    getHsabExpenseEvidenceShoeboxByPage (page: number, pageSize: number) {
        return `${this.expenseV2}/expenses/shoebox?page=${page}&pageSize=${pageSize}`;
    },
    getUserHasHealthPlanExpense () {
        return `${this.expenseV2}/managed-expenses/has-health-plan-expense`;
    },
    getSubmittedHsabExpenses (page: number, pageSize: number) {
        return `${this.expenseV2}/expenses/submitted?page=${page}&pageSize=${pageSize}`;
    },
    createOrUpdateHsabExpense () {
        return `${this.expenseV2}/expenses/create-or-update`;
    },
    submitHsabExpense (expenseId: number) {
        return `${this.expenseV2}/expenses/${expenseId}/submit`;
    },
    submitHsabExpenseEvidence (expenseId: number) {
        return `${this.expenseV2}/expenses/${expenseId}/submit-evidence`;
    },
    syncHsabExpenses () {
        return `${this.expenseV2}/expenses/sync`;
    },
    getHsabExpenseCategories () {
        return `${this.expenseV2}/expenses/categories`;
    },
    DeleteHsabExpense (expenseId: number) {
        return `${this.expenseV2}/expenses/${expenseId}`;
    },
    getHsabExpenseById (expenseId: number) {
        return `${this.expenseV2}/expenses/${expenseId}`;
    },
    getExpenseReimburseMeLimit () {
        return `${this.expenseV2}/expenses/reimburse-me-limit`;
    },
    getHsabExpenseByExternalId (request: HsabExpenseByExternalIdRequest) {
        let url = `${this.expenseV2}/expenses/expense-by-external-id?`;
        if (request.externalReimbursementId) {
            url += "externalReimbursementId=" + request.externalReimbursementId;
        } else if (request.externalTransactionId) {
            url += "externalTransactionId=" + request.externalTransactionId;
        }
        return url;
    },
    reimbursement () {
        return `${this.expenseV1}/reimbursement`;
    },
    unreimbursed (page: number, pageSize: number, receipts) {
        return `${this.expenseV1}/expenses/unreimbursed?page=${page}&pageSize=${pageSize}&receipts=${receipts}`;
    },
    unreimbursedCount: () => `${expenseV1}/expenses/unreimbursedCount`,
    unreimbursedWithoutAttachmentsCount: () => `${expenseV1}/expenses/unreimbursedNoReceiptsCount`,
    reimbursed (page: number, pageSize: number, excludeFailures: boolean) {
        return `${this.expenseV1}/reimbursement?page=${page}&pageSize=${pageSize}&excludeFailures=${excludeFailures}`;
    },
    reimbursedExpensesByReimbursementId (reimbursementId: number) {
        return `${this.expenseV1}/reimbursement/${reimbursementId}`;
    },
    reimbursedExpensesByBankTransactionIds (bankTransactionIds: string) {
        return `${this.expenseV1}/reimbursement/banktransactions/${bankTransactionIds}`;
    },
    unreimbursedGraph (startDate: string, endDate: string) {
        return `${this.expenseV1}/expenses/unreimbursedbalances?startDate=${startDate}&endDate=${endDate}`;
    },
    reimbursedMonthlySummary (startDate: string, endDate: string) {
        return `${this.expenseV1}/reimbursement/monthly-totals?startDate=${startDate}&endDate=${endDate}`;
    },
    createReimbursementRequest () {
        return `${this.expenseV1}/reimbursement/reimburserequest`;
    },
    updateReimbursementRequest (reimbursementRequestId: number) {
        return `${this.expenseV1}/reimbursement/reimburserequest/${reimbursementRequestId}`;
    },
    expenseAmountGroupByCategory (year?: number) {
        return `${this.expenseV1}/expenses/amount-by-category/${year || ""}`;
    },
    getImportedExpenses () {
        return `${this.expenseV1}/imported-expense`;
    },
    importedExpenseEvidenceDownload (reimbursedExpenseId: number, fileName: string) {
        return `${this.expenseV1}/imported-expense/download-link/${reimbursedExpenseId}/${fileName}`;
    },
    manualMarkedAsReimbursed () {
        return `${this.expenseV1}/reimbursement/manual-mark-reimbursed`;
    },
    getExpensesByIds () {
        return `${this.expenseV1}/expenses/expenses-by-ids`;
    },
    deleteExpense (expenseId: number) {
        return `${this.expenseV1}/expenses/${expenseId}`;
    },
    getAdminFinicityLinkedAccounts (cognitoUsername: string) {
        return `${this.expenseV1}/admin-finicity-linked-accounts?cognitoUsername=${cognitoUsername}`;
    },
    getPayeesForUser () {
        return `${this.expenseV1}/payees`;
    },
    createPayee () {
        return `${this.expenseV1}/payees`;
    },
    updatePayee () {
        return `${this.expenseV1}/payees`;
    },
    deletePayee (payeeId: number) {
        return `${this.expenseV1}/payees/${payeeId}`;
    },
    getExpenseEvidence (expenseId: number) {
        return `${this.expenseV2}/expenses/${expenseId}/evidence`;
    },
    deleteExpenseEvidence (expenseId: number, expenseEvidenceId: number) {
        return `${this.expenseV2}/expenses/${expenseId}/evidence/${expenseEvidenceId}`;
    },
    retrySubmitHsabExpenseEvidence (expenseId: number, expenseEvidenceId: number) {
        return `${this.expenseV2}/expenses/${expenseId}/evidence/${expenseEvidenceId}/submit`;
    },
    uploadFilesToHsabExpense (expenseId: number) {
        return `${this.expenseV2}/expenses/${expenseId}/evidence`;
    },
    CreateEvidenceAndMoveShoeboxFiles (expenseId: number) {
        return `${this.expenseV2}/expenses/${expenseId}/evidence/shoebox-upload`;
    },
    getHsabExpenseEvidenceSignedS3Url (expenseId: number, expenseEvidenceId: number) {
        return `${this.expenseV2}/expenses/${expenseId}/evidence/${expenseEvidenceId}/download-url`;
    },
    getHsabExpenseEvidenceShoeboxSignedS3Url (shoeboxId: number) {
        return `${this.expenseV2}/expenses/shoebox/${shoeboxId}/download-url`;
    },
    getConsumerBankAccounts () {
        return `${this.expenseV2}/consumer-bank-accounts/bank-accounts`;
    },
    doesFlowIdHaveAssociation (flowIds: string[]) {
        return `${this.expenseV2}/expense-reimbursements/check-flow-ids?${flowIds.map(x => "flowIds=" + x).join("&")}`;
    },
    RepayHsabExpenseReimbursement (hsabExpenseReimbursementId: number) {
        return `${this.expenseV2}/expense-reimbursements/${hsabExpenseReimbursementId}/repay-all-repayments`;
    },
    getUnusedDistributionById (reimbursmentId: number) {
        return `${this.expenseV2}/expense-reimbursements/get-unused-distribution?reimbursementId=${reimbursmentId}`;
    },
    deleteShoeboxFile (shoeboxFileId: number) {
        return `${this.expenseV2}/expenses/shoebox/${shoeboxFileId}`;
    },
    createAndUploadShoeboxFiles () {
        return `${this.expenseV2}/expenses/shoebox`;
    },
    getHsabExpenseStatusesByIds () {
        return `${this.expenseV2}/expenses/expense-statuses-by-ids`;
    }
};
